import { Modal, Toast } from "bootstrap";

declare var $: any;

interface QuoteLine {
    typeId: number;
    description: string;
    categoryId: number | null;
    quantity: number | null;
    unitPrice: number | null;
}

interface Category {
    Id: number;
    Name: string;
}

export class ISiteMobileQuotesSubmitQuotePage {
    private workOrderId: number = 0;
    private categories: Category[] = [];
    private draftKey: string = '';

    constructor() { }

    public Init(): void {
        this.renderImmediateDraft();

        var wrapperEl = document.getElementById('quoteWorkOrderId') as HTMLInputElement;
        if (!wrapperEl) return;
        if (wrapperEl.dataset.quoteInited === '1') return;
        wrapperEl.dataset.quoteInited = '1';

        this.workOrderId = parseInt($('#quoteWorkOrderId').val(), 10);
        var rawCategories = document.getElementById('quoteCategories')!.textContent;
        try { this.categories = JSON.parse(rawCategories!) || []; } catch (e) { this.categories = []; console.log('[SubmitQuote] categories JSON parse error', e); }
        this.draftKey = 'quote-draft:' + this.workOrderId;

        this.wireUpEvents();
        this.unblockPage();
        this.loadExistingQuote();
    }

    private renderImmediateDraft(): void {
        var woId = document.getElementById('quoteWorkOrderId') as HTMLInputElement;
        if (!woId) return;
        var key = 'quote-draft:' + woId.value;
        var raw: string | null;
        try { raw = localStorage.getItem(key); } catch (e) { return; }
        if (!raw) return;
        var lines: any[];
        try { lines = JSON.parse(raw); } catch (e) { return; }
        if (!Array.isArray(lines) || lines.length === 0) return;

        var tpl = document.getElementById('quoteRowTemplate') as HTMLTemplateElement;
        if (!tpl) return;
        var cats: Category[] = [];
        try { cats = JSON.parse(document.getElementById('quoteCategories')!.textContent!) || []; } catch (e) { }

        function catOptions(selectedId: any): string {
            var h = '<option value=""></option>';
            for (var i = 0; i < cats.length; i++) {
                var c = cats[i];
                h += '<option value="' + c.Id + '"' + (selectedId == c.Id ? ' selected' : '') + '>' + c.Name.replace(/</g, '&lt;') + '</option>';
            }
            return h;
        }

        var sections = document.querySelectorAll('.quote-section');
        sections.forEach(function (sec) {
            var typeId = parseInt(sec.getAttribute('data-typeid')!, 10);
            var tbody = sec.querySelector('.quote-rows');
            if (!tbody) return;
            var sectionTotal = 0;
            lines.filter(function (l) { return l.typeId === typeId; }).forEach(function (l) {
                var row = (tpl.content.firstElementChild as HTMLElement).cloneNode(true) as HTMLElement;
                row.querySelector('.q-category')!.innerHTML = catOptions(l.categoryId);
                if (l.quantity != null) row.querySelector('.q-quantity')!.setAttribute('value', l.quantity);
                if (l.description) row.querySelector('.q-description')!.setAttribute('value', l.description);
                if (l.unitPrice != null) row.querySelector('.q-price')!.setAttribute('value', l.unitPrice);
                tbody!.appendChild(row);
                var qty = parseFloat(l.quantity) || 0;
                var price = parseFloat(l.unitPrice) || 0;
                sectionTotal += qty > 0 ? qty * price : price;
            });
            var totalEl = sec.querySelector('.quote-section-total');
            if (totalEl) totalEl.textContent = sectionTotal.toFixed(2);
        });
        var grandEl = document.getElementById('quoteGrandTotal');
        if (grandEl) {
            var g = 0;
            sections.forEach(function (sec) {
                var t = sec.querySelector('.quote-section-total');
                if (t) g += parseFloat(t.textContent!) || 0;
            });
            grandEl.textContent = g.toFixed(2);
        }
    }

    private readDraft(): QuoteLine[] {
        try {
            var raw = localStorage.getItem(this.draftKey);
            var parsed = raw ? JSON.parse(raw) : null;
            return Array.isArray(parsed) ? parsed : [];
        } catch (e) {
            return [];
        }
    }

    private writeDraft(lines: QuoteLine[]): void {
        try { localStorage.setItem(this.draftKey, JSON.stringify(lines || [])); }
        catch (e) { console.warn('Save failed', e); }
    }

    private clearDraft(): void {
        try { localStorage.removeItem(this.draftKey); } catch (e) { }
    }

    private snapshotDraftFromDom(): QuoteLine[] {
        var lines: QuoteLine[] = [];
        $('.quote-section').each(function (this: any) {
            var typeId = parseInt($(this).attr('data-typeid'), 10);
            $(this).find('.quote-row').each(function (this: any) {
                var $r = $(this);
                var catVal = $r.find('.q-category').val();
                var qty = $r.find('.q-quantity').val();
                var price = $r.find('.q-price').val();
                lines.push({
                    typeId: typeId,
                    description: ($r.find('.q-description').val() || '').trim(),
                    categoryId: catVal ? parseInt(catVal, 10) : null,
                    quantity: qty === '' ? null : parseFloat(qty),
                    unitPrice: price === '' ? null : parseFloat(price)
                });
            });
        });
        return lines;
    }

    private persistDraft(): void { this.writeDraft(this.snapshotDraftFromDom()); }

    private showStatus(message: string, kind: string): void {
        var toastId = (kind === 'error') ? '#quoteFailureToast' : '#quoteSuccessToast';
        var $toast = $(toastId);
        if ($toast.length === 0) { console.warn('Quote toast element missing:', toastId, message); return; }
        $toast.find('.quote-toast-message').text(message);

        if ($toast.parent()[0] !== document.body) {
            $toast.appendTo(document.body);
        }

        var tryShow = function (attempt: number) {
            try {
                var t = Toast.getOrCreateInstance($toast[0]);
                t.show();
                return;
            } catch (e) {
                console.warn('Toast show failed', e);
            }
            if (attempt < 40) {
                setTimeout(function () { tryShow(attempt + 1); }, 50);
            } else {
                $toast.addClass('show').css('display', 'block');
                setTimeout(function () { $toast.removeClass('show').css('display', ''); }, 4000);
            }
        };
        tryShow(0);
    }

    private showBanner(message: string, kind: string): void {
        this.showStatus(message, kind);
    }

    private categoryOptionsHtml(selectedId: number | null): string {
        var html = '<option value=""></option>';
        this.categories.forEach(function (c) {
            html += '<option value="' + c.Id + '"' + (selectedId == c.Id ? ' selected' : '') + '>' + $('<div>').text(c.Name).html() + '</option>';
        });
        return html;
    }

    private toDecimal(v: any): number {
        var n = parseFloat(v);
        return isNaN(n) ? 0 : n;
    }

    private formatMoney(n: number): string {
        return (Math.round(n * 100) / 100).toFixed(2);
    }

    private recalcTotals(): void {
        var self = this;
        var grand = 0;
        $('.quote-section').each(function (this: any) {
            var sectionTotal = 0;
            $(this).find('.quote-row').each(function (this: any) {
                var qty = self.toDecimal($(this).find('.q-quantity').val());
                var price = self.toDecimal($(this).find('.q-price').val());
                var line = qty > 0 ? qty * price : price;
                sectionTotal += line;
            });
            $(this).find('.quote-section-total').text(self.formatMoney(sectionTotal));
            grand += sectionTotal;
        });
        $('#quoteGrandTotal').text(this.formatMoney(grand));
    }

    private setRowEditable($row: any, editable: boolean): void {
        $row.find('input').prop('disabled', !editable);
        // Category dropdown only applies to the 'Other' section (typeid 3).
        if ($row.closest('.quote-section').attr('data-typeid') === '3') {
            $row.find('.q-category').prop('disabled', !editable);
        }
        $row.find('.q-edit').toggle(!editable);
        $row.find('.q-save').toggle(editable);
        if (editable) {
            $row.find('.q-description').focus();
        }
    }

    private buildRow(detail: QuoteLine | null): any {
        var tpl = document.getElementById('quoteRowTemplate') as HTMLTemplateElement;
        var $row = $(tpl.content.firstElementChild!.cloneNode(true));
        $row.find('.q-category').html(this.categoryOptionsHtml(detail ? detail.categoryId : null));
        if (detail) {
            $row.attr('data-id', 0);
            $row.attr('data-quoteid', 0);
            $row.find('.q-quantity').attr('value', detail.quantity == null ? '' : detail.quantity);
            $row.find('.q-description').attr('value', detail.description || '');
            $row.find('.q-price').attr('value', detail.unitPrice == null ? '' : detail.unitPrice);
        }
        return $row;
    }

    private validateRow($row: any): boolean {
        var desc = ($row.find('.q-description').val() || '').trim();
        if (!desc) { this.showStatus('Description is required.', 'error'); return false; }
        if (desc.length > 1000) { this.showStatus('Description must be 1000 chars or fewer.', 'error'); return false; }
        var qty = $row.find('.q-quantity').val();
        if (qty !== '' && (isNaN(parseFloat(qty)) || parseFloat(qty) < 0)) {
            this.showStatus('Quantity must be a non-negative number.', 'error'); return false;
        }
        var price = $row.find('.q-price').val();
        if (price !== '' && (isNaN(parseFloat(price)) || parseFloat(price) < 0)) {
            this.showStatus('Unit Price must be a non-negative number.', 'error'); return false;
        }
        return true;
    }

    private saveRow($row: any): any {
        if (!this.validateRow($row)) return $.Deferred().reject().promise();
        this.setRowEditable($row, false);
        this.recalcTotals();
        this.persistDraft();
        return $.Deferred().resolve().promise();
    }

    private deleteRow($row: any): void {
        var self = this;
        var modalEl = document.getElementById('quoteDeleteModal')!;
        var modal = new Modal(modalEl, { backdrop: 'static', keyboard: false });
        $('#quoteDeleteModalConfirm').off('click.quoteDelete').on('click.quoteDelete', function () {
            modal.hide();
            $row.remove();
            self.recalcTotals();
            self.persistDraft();
            self.showStatus('Line deleted.', 'success');
        });
        modal.show();
    }

    private loadAllDetails(quoteId: number): any {
        var self = this;
        var t0 = performance.now();
        return $.ajax({
            url: (window as any)._iSitePathBase + 'Quotes/AllDetails?quoteId=' + quoteId,
            method: 'GET',
            dataType: 'json',
            timeout: 30000
        })
            .done(function (list: any[]) {
                list = list || [];
                var byType: any = {};
                list.forEach(function (d) {
                    var t = d.typeId;
                    (byType[t] = byType[t] || []).push(d);
                });
                $('.quote-section').each(function (this: any) {
                    var $section = $(this);
                    var typeId = parseInt($section.attr('data-typeid'), 10);
                    var $tbody = $section.find('.quote-rows');
                    var $userRows = $tbody.children('.quote-row').detach();
                    (byType[typeId] || []).forEach(function (d: any) {
                        $tbody.append(self.buildRow(d));
                    });
                    $tbody.append($userRows);
                });
            })
            .fail(function (xhr: any) {
                console.error('Load failed', xhr.status, xhr.responseText);
            });
    }

    private resetPageForNewQuote(): void {
        $('.quote-section').each(function (this: any) {
            $(this).find('.quote-rows').children('.quote-row').remove();
        });
        this.recalcTotals();
    }

    private setFooterBtnBusy($btn: any, busy: boolean): void {
        $btn.prop('disabled', busy);
        $btn.find('.quote-btn-icon-default').toggleClass('d-none', busy);
        $btn.find('.quote-btn-spinner').toggleClass('d-none', !busy);
    }

    private blockPage(): void { $('#quotePageBlocker').addClass('is-visible'); }
    private unblockPage(): void { $('#quotePageBlocker').removeClass('is-visible'); }

    private renderDraft(lines: QuoteLine[]): void {
        var self = this;
        $('.quote-section').each(function (this: any) {
            var $section = $(this);
            var typeId = parseInt($section.attr('data-typeid'), 10);
            var $tbody = $section.find('.quote-rows');
            $tbody.children('.quote-row').remove();
            (lines || [])
                .filter(function (l) { return l.typeId === typeId; })
                .forEach(function (l) { $tbody.append(self.buildRow(l)); });
        });
        this.recalcTotals();
    }

    private loadExistingQuote(): void {
        var existingRows = $('.quote-rows .quote-row').length;
        if (existingRows > 0) {
            this.recalcTotals();
            return;
        }
        var draft = this.readDraft();
        if (draft.length > 0) {
            this.renderDraft(draft);
            this.recalcTotals();
        }
    }

    private syncLineToServer(line: QuoteLine, quoteIdRef: { value: number }): any {
        var detail = {
            Id: 0,
            QuoteId: quoteIdRef.value || 0,
            Description: line.description || '',
            Reference: '',
            TypeId: line.typeId,
            CategoryId: line.categoryId == null ? null : line.categoryId,
            CategoryName: null,
            Quantity: line.quantity == null ? null : line.quantity,
            UnitPrice: line.unitPrice == null ? null : line.unitPrice
        };
        var body = { Detail: detail, CurrentQuoteId: quoteIdRef.value };
        return $.ajax({
            url: (window as any)._iSitePathBase + 'Quotes/SaveDetail?workOrderId=' + this.workOrderId,
            method: 'POST',
            contentType: 'application/json',
            data: JSON.stringify(body)
        }).done(function (resp: any) {
            if (resp && resp.success && resp.detail && resp.detail.quoteId) {
                quoteIdRef.value = resp.detail.quoteId;
            } else {
                console.warn('Response missing quoteId', resp);
            }
        }).fail(function (xhr: any) {
            console.error('Sync line to server failed status=' + xhr.status, xhr.responseText);
        });
    }

    // ---- Event wiring ----
    private wireUpEvents(): void {
        var self = this;

        $(document).off('.quotePage');

        $(document).on('click.quotePage', '.quote-add-row', function (this: any) {
            var $section = $(this).closest('.quote-section');
            var $row = self.buildRow(null);
            $section.find('.quote-rows').append($row);
            self.setRowEditable($row, true);
        });

        $(document).on('click.quotePage', '.q-edit', function (this: any) {
            self.setRowEditable($(this).closest('.quote-row'), true);
        });

        $(document).on('click.quotePage', '.q-save', function (this: any) {
            var $row = $(this).closest('.quote-row');
            self.saveRow($row);
        });

        $(document).on('input.quotePage change.quotePage', '.q-quantity, .q-price', function (this: any) {
            self.recalcTotals();
        });

        $(document).on('click.quotePage', '.q-delete', function (this: any) {
            self.deleteRow($(this).closest('.quote-row'));
        });

        $(document).on('click.quotePage', '#btnSaveQuote', function (this: any) {
            var $btn = $(this);

            var invalid = false;
            $('.quote-row').filter(function (this: any) {
                return !$(this).find('.q-description').prop('disabled');
            }).each(function (this: any) {
                var $row = $(this);
                if (!self.validateRow($row)) { invalid = true; return; }
                self.setRowEditable($row, false);
            });
            if (invalid) {
                self.showBanner('Please fix the highlighted lines before saving.', 'error');
                return;
            }

            self.setFooterBtnBusy($btn, true);
            try {
                self.recalcTotals();
                self.persistDraft();
                self.showBanner('Quote saved to device.', 'success');
            } catch (e) {
                self.showBanner('Quote could not be saved to device.', 'error');
            } finally {
                self.setFooterBtnBusy($btn, false);
            }
        });

        $(document).on('click.quotePage', '#btnSubmitQuote', function (this: any) {
            var $btn = $(this);
            var proceed = function () {
                self.setFooterBtnBusy($btn, true);
                self.blockPage();

                var localSaveOk = true;
                $('.quote-row').filter(function (this: any) {
                    return !$(this).find('.q-description').prop('disabled');
                }).each(function (this: any) {
                    var $row = $(this);
                    if (!self.validateRow($row)) { localSaveOk = false; return; }
                    self.setRowEditable($row, false);
                });
                self.recalcTotals();
                self.persistDraft();

                if (!localSaveOk) {
                    self.unblockPage();
                    self.setFooterBtnBusy($btn, false);
                    self.showBanner('Please fix the highlighted lines before submitting.', 'error');
                    return;
                }

                var draft = self.readDraft();
                if (draft.length === 0) {
                    self.unblockPage();
                    self.setFooterBtnBusy($btn, false);
                    self.showBanner('Add at least one line before submitting.', 'error');
                    return;
                }

                var quoteIdRef = { value: 0 };
                var syncFailed = false;
                var chain: any = $.Deferred().resolve();
                draft.forEach(function (line, idx) {
                    chain = chain.then(
                        function () {
                            if (syncFailed) return $.Deferred().reject().promise();
                            return self.syncLineToServer(line, quoteIdRef);
                        },
                        function () {
                            syncFailed = true;
                            return $.Deferred().reject().promise();
                        }
                    );
                });

                chain.then(function () {
                    if (!quoteIdRef.value) {
                        return $.Deferred().reject({ __clientMessage: 'Server did not return a quote id.' }).promise();
                    }
                    return $.ajax({
                        url: (window as any)._iSitePathBase + 'Quotes/Submit?quoteId=' + quoteIdRef.value,
                        method: 'POST'
                    });
                }).done(function (resp: any) {
                    if (resp && resp.success) {
                        self.clearDraft();
                        self.resetPageForNewQuote();
                        self.showBanner('Quote submitted successfully.', 'success');
                        setTimeout(function () {
                            window.location.href = (window as any)._iSitePathBase + 'WorkOrder/View/' + self.workOrderId;
                        }, 1200);
                    } else {
                        self.showBanner('Submit returned an unexpected response.', 'error');
                    }
                }).fail(function (xhr: any) {
                    var saveFailed = syncFailed;
                    if (saveFailed) {
                        self.showBanner('Quote could not be submitted: one or more lines failed to save.', 'error');
                        return;
                    }
                    if (xhr && xhr.__clientMessage) {
                        self.showBanner(xhr.__clientMessage, 'error');
                        return;
                    }
                    if (xhr && xhr.status === 409) {
                        var msg409 = 'That quote had already been submitted. Starting a new quote.';
                        try { msg409 = (xhr.responseJSON && xhr.responseJSON.message) || msg409; } catch (e) { }
                        self.showBanner(msg409, 'error');
                        self.clearDraft();
                        self.resetPageForNewQuote();
                        return;
                    }
                    var msg = 'Submit failed.';
                    try { msg = (xhr.responseJSON && xhr.responseJSON.message) || msg; } catch (e) { }
                    self.showBanner(msg + (xhr && xhr.status ? ' (HTTP ' + xhr.status + ')' : ''), 'error');
                }).always(function () {
                    self.unblockPage();
                    self.setFooterBtnBusy($btn, false);
                });
            };

            var modalEl = document.getElementById('quoteSubmitModal')!;
            var modal = new Modal(modalEl, { backdrop: 'static', keyboard: false });
            $('#quoteSubmitModalConfirm').off('click.quoteSubmit').on('click.quoteSubmit', function () {
                modal.hide();
                proceed();
            });
            modal.show();
        });
    }
}
